//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'

export default {
  props: {
    physicalInStock: { type: Boolean, required: true }
  },
  data: () => ({
    value: 50,
    includeShipping: false,
    mode: 'physical'
  }),
  computed: {
    ...mapGetters({
      currencySymbol: 'store/currencySymbol'
    }),
    digitalMode () {
      return this.mode === 'digital'
    },
    physicalMode () {
      return this.mode === 'physical'
    },
    bundle () { return this.$store.getters['product/bundle'](this.baseSku) || {} },
    baseSku () {
      return this.digitalMode ? 'egiftcard' : 'pgiftcard'
    },
    sku () {
      return `${this.baseSku}-${this.value}`
    },
    incrementOptionId () {
      return this.getOptionId('gc_increment')
    },
    incrementSelectionId () {
      return this.getSelectionId('gc_increment')
    },
    shippingOptionId () {
      return this.getOptionId('gs_shipping')
    },
    shippingSelectionId () {
      return this.getSelectionId('gs_shipping')
    },
    cardOptionId () {
      return this.getOptionId('gc_card')
    },
    cardSelectionId () {
      return this.getSelectionId('gc_card')
    },
    queryOptions () {
      const queryOptions = {
        bundle_option: { [this.incrementOptionId]: this.incrementSelectionId },
        bundle_option_qty: { [this.incrementOptionId]: this.value },
        product: this.bundle.bundleId
      }

      if (this.includeShipping) {
        queryOptions.bundle_option[this.shippingOptionId] = this.shippingSelectionId
        queryOptions.bundle_option_qty[this.shippingOptionId] = 1
      }

      if (this.physicalMode) {
        queryOptions.options = { 3: Math.ceil(Math.random() * 1e6) }
        queryOptions.bundle_option[this.cardOptionId] = this.cardSelectionId
        queryOptions.bundle_option_qty[this.cardOptionId] = 1
      }

      return queryOptions
    },
    shippingPrice () {
      return this.getBundleItem('gs_shipping').price || 6.95
    }
  },
  mounted () {
    if (!this.physicalInStock && this.physicalMode) this.mode = 'digital'
  },
  methods: {
    async addToCart () {
      const success = await this.$store.dispatch('cart/ADD_TO_CART', [this.queryOptions, this.sku])
      if (success) this.$router.push({ path: this.localePath('/checkout/cart/') })
    },
    setValue (value) {
      this.value = value
    },
    getOptionId (sku) {
      const search = Object.entries(this.bundle.options).find(
        ([optionId, option]) => Object.entries(option.selections).find(([selectionId, selection]) => selection.sku === sku)
      )
      if (search) return search[0]
      return null
    },
    getBundleItem (sku) {
      return Object.values(this.bundle.options).map(
        option => Object.entries(option.selections).map(
          ([selectionId, selection]) => {
            selection.selectionId = selectionId
            return selection
          }
        )
      ).flat().find(
        selection => selection.sku === sku
      ) || {}
    },
    getSelectionId (sku) {
      return this.getBundleItem(sku).selectionId
    },
    switchMode (mode) {
      if (this.mode === mode) return
      this.mode = mode
    }
  }
}
